import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
import { gsap } from 'gsap';
import { namespace } from 'vuex-class';

const appModule = namespace('app');

@Component({})
export default class DirectCodeInputAnimations extends Vue {
  public arrowLoopTl!: GSAPTimeline;

  @Ref('arrow') arrowEl!: Vue;
  @appModule.State public initialAnimationCompleted!: boolean;

  public mounted() {
    if (!this.initialAnimationCompleted) {
      gsap.set([this.$el, this.arrowEl.$el], { opacity: 0 });
    } else {
      this.arrowLoop();
    }
  }

  public swapEnter(el: HTMLElement, done: () => void) {
    gsap.fromTo(el, { opacity: 0, x: -10 }, { opacity: 1, x: 0, duration: 0.5, onComplete: done });
  }

  public swapLeave(el: HTMLElement, done: () => void) {
    gsap.fromTo(el, { opacity: 1, x: 0 }, { opacity: 0, x: 10, duration: 0.5, onComplete: done });
  }

  @Watch('initialAnimationCompleted')
  public onInitialAnimationCompleted() {
    gsap.fromTo(this.$el, { opacity: 0, x: -20 }, { opacity: 1, x: 0, duration: 1, onComplete: this.arrowLoop });
  }

  public arrowLoop() {
    if (this.arrowEl)
      this.arrowLoopTl = gsap
        .timeline({ repeat: -1, repeatDelay: 1 })
        .fromTo(this.arrowEl.$el, { opacity: 0, x: -5 }, { opacity: 1, x: 0, duration: 1 })
        .to(this.arrowEl.$el, { opacity: 0, x: 5, duration: 1 })
        .set(this.arrowEl.$el, { x: -5, delay: 0.2 });
  }
}
